import React, { useState, useEffect, useContext, useCallback, } from "react";
// External Components
import { format, set } from "date-fns";
import { DesktopDateTimePicker } from "@mui/x-date-pickers/DesktopDateTimePicker";
import { ThemeProvider } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import { convertToTimeZone, convertToLocalTime } from "date-fns-timezone";
import { renderTimeViewClock } from "@mui/x-date-pickers";
// Internal
import AccountContext from "../account/AccountContext";
import datePickerTheme from "./theme";
var useStyles = makeStyles(function (_a) {
    var _b;
    var breakpoints = _a.breakpoints;
    return ({
        width: {
            width: "100%",
        },
        containerWidth: (_b = {
                width: "100%"
            },
            _b[breakpoints.down("md")] = {
                display: "block",
            },
            _b),
    });
});
// TODO Move date conversion functions into dateUtil
// NOTE VUI-116: To make sure we get the correct information from the backend we have to explicitly remove s/ms from the date
// E.g.: You selected 12:10am but you may be sending backend "12:10:20.789" which would miss data that was set to "12:10:5:15"
export var removeSeconds = function (date) {
    return set(date, { seconds: 0, milliseconds: 0 });
};
// NOTE This function will convert your date to the specified timezone.
// On inital render and if no account is selected our timezone context is set to an empty string ""
// convertToTimeZone does not accept an empty string so instead we return the provided date
export var convertToTZ = function (date, timeZone) {
    return timeZone ? convertToTimeZone(date, { timeZone: timeZone }) : date;
};
// NOTE This function will convert date to TZ and remove seconds/miliseconds from the date
export var convertTo0secTZ = function (date, timeZone) {
    return removeSeconds(convertToTZ(date, timeZone));
};
export var formatString = "MM/dd/yyyy hh:mm aa";
export default (function (_a) {
    var id = _a.id, value = _a.value, onChange = _a.onChange, label = _a.label, min = _a.min, max = _a.max;
    var timeZone = useContext(AccountContext).timeZone;
    var _b = useState(null), dateTime = _b[0], setDateTime = _b[1];
    var _c = useState(false), hasStartError = _c[0], setStartError = _c[1];
    var _d = useState(undefined), startErrorMsg = _d[0], setStartErrorMsg = _d[1];
    var handleChange = useCallback(function (newDate) {
        if (newDate && timeZone) {
            onChange(convertToLocalTime(newDate, { timeZone: timeZone }));
        }
        else {
            onChange(newDate);
        }
    }, [onChange, timeZone]);
    var calcMinMax = function (minOrMax) {
        if (minOrMax === undefined) {
            return undefined;
        }
        if (typeof minOrMax === "function") {
            return minOrMax(timeZone);
        }
        return convertToTZ(minOrMax, timeZone);
    };
    var minDate = calcMinMax(min);
    var maxDate = calcMinMax(max);
    var formatedMaxDate = maxDate ? format(maxDate, formatString) : "";
    var formatedMinDate = minDate ? format(minDate, formatString) : "";
    var isBeforeMaxDate = !dateTime || !maxDate || dateTime <= maxDate;
    var isAfterMinDate = !dateTime || !minDate || dateTime >= minDate;
    var isValidDate = isBeforeMaxDate && isAfterMinDate;
    useEffect(function () {
        setDateTime(convertTo0secTZ(value, timeZone));
    }, [value, timeZone]);
    // NOTE This useEffect will reset the error state if the date is valid
    useEffect(function () {
        if (isValidDate) {
            setStartError(false);
            setStartErrorMsg(undefined);
        }
    }, [isValidDate]);
    var acceptValidDate = function () {
        if (dateTime !== null && isValidDate) {
            handleChange(dateTime);
            // everything is fine
            setStartError(false);
            setStartErrorMsg(undefined);
        }
        else {
            // the native error handling doesn't pick this situation up because we don't respect the change
            // so we handle it ourselves
            setStartError(true);
            // wanted to do this as a ternary, lint complained
            if (isBeforeMaxDate) {
                // it's too early
                setStartErrorMsg("Date should not be before ".concat(formatedMinDate));
            }
            else {
                setStartErrorMsg("Date should not be after ".concat(formatedMaxDate));
            }
        }
    };
    var onEnterPress = function (_a) {
        var key = _a.key;
        if (key === "Enter") {
            acceptValidDate();
        }
    };
    var classes = useStyles();
    return (React.createElement(ThemeProvider, { theme: datePickerTheme },
        React.createElement(DesktopDateTimePicker, { format: formatString, className: classes.containerWidth, viewRenderers: {
                hours: renderTimeViewClock,
                minutes: renderTimeViewClock,
            }, 
            // Props applied to the MUI Input component
            slotProps: {
                tabs: {
                    hidden: false,
                },
                textField: {
                    className: classes.width,
                    InputLabelProps: { shrink: true },
                    error: hasStartError,
                    helperText: startErrorMsg,
                    onBlur: acceptValidDate,
                    onKeyPress: onEnterPress,
                    variant: "standard",
                },
            }, onError: function (error) {
                if (error === "invalidDate") {
                    setStartErrorMsg("Invalid date. Use ".concat(formatString));
                }
                if (error === "maxDate") {
                    setStartErrorMsg("Date should not be after ".concat(formatedMaxDate));
                }
                if (error === "minDate") {
                    setStartErrorMsg("Date should not be before ".concat(formatedMinDate));
                }
            }, label: label, maxDate: maxDate, minDate: minDate, onClose: acceptValidDate, onChange: setDateTime, value: dateTime })));
});
//# sourceMappingURL=index.js.map